<template>
    <section class="bg-white py-4 pb-2 px-4 rounded-2xl">
        <h1 class="text-xl text-primary font-bold">Ranking</h1>
        <p class="text-sm">Confira os seus rankings </p>
        <div class="flex flex-col xl:flex-row gap-x-6 mt-2">
            <div class="flex flex-col justify-center w-full bg-gray-100 px-14 pt-10 pb-9 mt-2 rounded-2xl items-center">
                <p class="text-2xl font-bold text-primary whitespace-nowrap py-4">Em Breve</p>
                <!-- <p class="text-2xl font-bold text-primary whitespace-nowrap">1º lugar</p>
                <p class="font-bold text-primary whitespace-nowrap mt-2.5">Faturamento</p> -->
            </div>
            <div class="flex flex-col justify-center w-full bg-gray-100 px-14 pt-10 pb-9 mt-2 rounded-2xl items-center">
                <p class="text-2xl font-bold text-primary whitespace-nowrap py-4">Em Breve</p>
                <!-- <p class="text-2xl font-bold text-primary whitespace-nowrap">5º lugar</p>
                <p class="font-bold text-primary whitespace-nowrap mt-2.5">Cobertura</p> -->
            </div>
        </div>
        <div class="xl:flex items-center justify-between">
            <div class="text-sm mt-4 flex pb:flex-col gap-x-2 justify-between text-gray-600">
                <a class="flex whitespace-nowrap pb:order-1">Conferir desempenho <Icon class="text-black w-4" name="SetaDireita"/></a>
                <p class="text-[10px] text-left flex items-center">Última atualização: {{ lastUpdate ? formatUpdatedDate(lastUpdate) : getCurrentDate() }}</p>
            </div>
    </div>
    </section>
</template>
<script>
import Icon from '@/Components/UI/Icons/Icon.vue'
import moment from 'moment'
export default {
    methods: {
        getCurrentDate : function () {
            return new moment().format('DD/MM/YYYY [às] HH:mm');
        }
    },
    components: {
        Icon
    },
    props: {

    }
}
</script>
